<div
  class="w-full flex justify-between items-center"
  [class.bg-transparent]="transparent"
  [class.bg-white]="!transparent"
  [class.toolbar-wide-center]="wideCenter"
>
  <!-- Left side -->
  <div class="h-[52px] flex justify-start items-center flex-1 cursor-pointer">
    <div class="px-5 py-4" *ngIf="backButton" (click)="back()">
      <ark-lib-icon-name
        name="arrow-left"
        [classes]="
          transparent
            ? '[&>svg>path]:stroke-white ' + iconBackClass
            : iconBackClass
        "
      ></ark-lib-icon-name>
    </div>

    <ng-content select="[left]"></ng-content>
  </div>

  <!-- Center -->
  <div class="flex-1">
    <ng-content select="[center]"></ng-content>
  </div>

  <!-- Right side -->
  <div class="flex justify-end items-center flex-1">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
